// Texte, die einmal für die ganze Seite gelten (Spec Abschnitt 7): sie liegen in
// EINER Datei je App, damit ein späterer Umzug nach Mongo eine Datei betrifft.
export const LABELS = {
    // Titel der Uebersicht im Browser-Tab und Hinweis fuer Links in neue Tabs (#178)
    overviewTitle: 'Events',
    opensNewTab: '(öffnet in neuem Tab)',
    initiativeBy: 'Eine Initiative von:',
    exhibitorJobs: 'Stellenanzeigen',
    more: 'mehr erfahren »',
    comingSoon: 'coming soon …',
    // Ein alter Ergebnis-Link, dessen Stand es nicht mehr gibt (Spec 2026-10-06, 3.5).
    resultGone: 'Dieser Ergebnis-Stand ist nicht mehr verfügbar.',
    // Kurzform nur fuer Screenreader im Skeleton (EventSkeleton, #111)
    loading: 'Lädt …',
    loadingEvents: 'Events werden geladen …',
    loadingMembers: 'Mitglieder werden geladen …',
    loadingSection: 'Wird geladen …',
    empty: 'Zurzeit sind keine Events eingetragen.',
    error: 'Die Daten konnten nicht geladen werden.',
    wpPagesError: 'Weitere Unterseiten konnten nicht geladen werden.',
    filterAll: 'Alle',
    searchLabel: 'Suchen:',
    noExhibitors: 'Für diese Messe sind noch keine Aussteller erfasst.',
    internshipsIntro: 'Hier finden Sie eine aktuelle Übersicht der Aussteller, die Praktikumsplätze anbieten.',
    noProfessions: 'Keine Berufe erfasst.',
    // Bereichsliste in der Sidebar der Abschnittsseiten (Spec-Aenderung 2026-09-30)
    sectionNav: 'Bereiche der Messe',
    azFilter: 'Aussteller nach Anfangsbuchstabe',
    sectionNavToggle: 'Alle Bereiche der Messe',
    backToEvent: '« Zurück zur Messe'
}

// Stationen des Breadcrumb-Pfads. Der Start verweist auf die WordPress-Seite
// ausserhalb der React-App (#82).
export const BREADCRUMB = {
    start: 'Start',
    events: 'Events'
}
